import { lowerCase, upperFirst } from 'lodash';

export function titleCase(value: string): string {
  if (!value) {
    return '';
  }

  return upperFirst(lowerCase(value));
}
